/**
 * WineChap Attribution Tracker
 * Include in theme.liquid or as a Shopify asset
 * Tracks add-to-basket and checkout clicks within 1 day of a WineChap conversation
 *
 * Logged-in customers are identified by the signed window.WineChapAuth rendered in
 * theme.liquid (same as winechap.js). The worker only records events against a
 * customer ID that carries a valid signature; everyone else is tracked by anon ID.
 */
(function () {
  'use strict';

  var WORKER_URL   = 'https://hg-shop-assistant.simon-4b6.workers.dev';
  var STORAGE_KEY  = 'hg_winechap_v1';
  var ANON_KEY     = 'hg_wc_anon_id';
  var WINDOW_MS    = 24 * 60 * 60 * 1000; // 1 day

  // Signed customer identity from theme.liquid, or null
  function getCustomerAuth() {
    var a = window.WineChapAuth;
    if (!a || !/^\d+$/.test(String(a.id || '')) || !/^\d+$/.test(String(a.ts || '')) || !/^[0-9a-f]{64}$/i.test(String(a.sig || ''))) return null;
    return { id: String(a.id), ts: String(a.ts), sig: String(a.sig) };
  }

  function getConversationId() {
    // Returns the signed-in customer ID if available, otherwise the anon ID
    try {
      var auth = getCustomerAuth();
      if (auth) return auth.id;
      return localStorage.getItem(ANON_KEY) || null;
    } catch (_) { return null; }
  }

  function getLastChatTs() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var messages = (JSON.parse(raw).messages || []);
      if (!messages.length) return null;
      return messages[messages.length - 1].ts || null;
    } catch (_) { return null; }
  }

  function isWithinWindow() {
    var lastTs = getLastChatTs();
    if (!lastTs) return false;
    return (Date.now() - lastTs) < WINDOW_MS;
  }

  function getProductTitle() {
    try {
      // Try Shopify meta first
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
        return window.ShopifyAnalytics.meta.product.title || '';
      }
      // Fall back to page h1
      var h1 = document.querySelector('.product__title, h1.product-single__title, h1');
      return h1 ? h1.textContent.trim() : document.title;
    } catch (_) { return document.title; }
  }

  function track(eventName, product) {
    var conversationId = getConversationId();
    if (!conversationId) return;
    if (!isWithinWindow()) return;

    var headers = { 'Content-Type': 'application/json' };
    var auth = getCustomerAuth();
    if (auth) {
      headers['X-Customer-Id']  = auth.id;
      headers['X-Customer-Ts']  = auth.ts;
      headers['X-Customer-Sig'] = auth.sig;
    }

    fetch(WORKER_URL + '/track', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        event:           eventName,
        product:         product || '',
        url:             window.location.href,
        conversation_id: conversationId,
      }),
      keepalive: true, // fire-and-forget even if page navigates
    }).catch(function () {}); // silent fail — never interrupt checkout
  }

  function attachListeners() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('button, [type="submit"]');
      if (!btn) return;

      // Add to basket
      if (btn.name === 'add' && btn.classList.contains('product-form__submit')) {
        track('add_to_basket', getProductTitle());
        return;
      }

      // Checkout button (cart page or drawer)
      if (
        btn.name === 'checkout' ||
        (btn.textContent && btn.textContent.trim().toLowerCase() === 'check out')
      ) {
        track('checkout', '');
        return;
      }
    }, true); // capture phase so it fires before any other handlers
  }

  // Attach after DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachListeners);
  } else {
    attachListeners();
  }

}());